import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../../styles/styles';
import PropTypes from 'prop-types';
import {grey400} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import AdminService, {ADMIN} from "../../../../services/admin";
import withTranslation from "../../../../hoc/withTranslation";
import {EDIT_MEDIA_TYPE_PAGE, MEDIA_TYPE_PAGE} from "../../../../constants/routes";

class MediaType extends React.Component {

    static propTypes = {
        mediaType: PropTypes.object.isRequired,
        app: PropTypes.object,
        user: PropTypes.object,
        handleRemoveMediaType: PropTypes.func
    };

    handleRemoveMediaType = () => {
        this.props.handleRemoveMediaType(this.props.mediaType);
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                <Link to={MEDIA_TYPE_PAGE.replace(':appId', this.props.app.id).replace(':mediaTypeId', this.props.mediaType.id)}>
                    <MenuItem>
                        {this.props.t('generic.detail')}
                    </MenuItem>
                </Link>
                {AdminService.isAuthorized(ADMIN, this.props.user) &&
                <Link to={EDIT_MEDIA_TYPE_PAGE.replace(':appId', this.props.app.id).replace(':mediaTypeId', this.props.mediaType.id)}>
                    <MenuItem>
                        {this.props.t('generic.edit')}
                    </MenuItem>
                </Link>
                }
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.props.handleRemoveMediaType &&
                <MenuItem onClick={this.handleRemoveMediaType}>
                    {this.props.t('generic.remove')}
                </MenuItem>
                }
            </IconMenu>
        )
    };

    render() {
        const {mediaType} = this.props;

        return (
            <ListItem
                leftAvatar={
                    <Avatar
                        icon={mediaType.picture && <img src={mediaType.picture} alt="" style={style.image.contain}/>}
                        size={40}
                        backgroundColor={mediaType.color}
                        style={{ overflow: 'hidden' }}
                    />
                }
                primaryText={mediaType.name}
                secondaryText={mediaType.id}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(MediaType);



// WEBPACK FOOTER //
// src/components/media/MediaType/MediaType/MediaType.js